export default __webpack_public_path__ + "static/media/Logo.38966253.png";